import { Box, Button } from "@mui/material";
import { Form, Formik } from "formik";
import useBenefitingOrganizations from "hooks/useBenefitingOrganizations";
import useDonationRequests from "hooks/useDonationRequests";
import { useNavigate } from "react-router-dom";
import { donationRequestDefault, donationRequestSchema } from "types/donationRequest";
import DonationRequestForm from "./DonationRequestForm";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export default function AddNewDonationRequest() {
  const navigate = useNavigate();
  const { benefitingOrganizations, getBenefitingOrganization, benefitingOrganization } = useBenefitingOrganizations({
    returnAllResults: true,
  });
  const { createDonationRequest, setKey, key, deleteHeroImage } = useDonationRequests();
  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Tech Access" }, { label: "Donation Requests", path: "/donation-requests" }]} />
      <PageTitle>Donation Requests</PageTitle>
      <PageSubtitle>
        Fill out the fields below to create a donation request to be displayed in our Revivn platform feed.
      </PageSubtitle>
      <Box sx={{ padding: 3 }}>
        <Formik
          initialValues={donationRequestDefault}
          validationSchema={donationRequestSchema}
          onSubmit={(values) => {
            createDonationRequest(values);
            navigate(-1);
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Box textAlign="right"></Box>
              <DonationRequestForm
                getBenefitingOrganization={getBenefitingOrganization}
                benefitingOrganization={benefitingOrganization}
                benefitingOrganizations={benefitingOrganizations}
                setKey={setKey}
                signedKey={key}
                deleteHeroImage={deleteHeroImage}
              />
              <Button variant="contained" type="submit" disabled={isSubmitting}>
                Add donation request
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </AutoPagePaperLayout>
  );
}
